import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'OrganizedUnit/GetAllLegalCompanyCombo', method: 'GET', body: null, token: token })
}
